import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../components/ui/Card";
import { Badge } from "../components/ui/Badge";
import { Skeleton } from "../components/ui/Skeleton";
import { useDomainStore } from "../stores/domainStore";

export default function DomainListPage() {
  const { domains, isLoading } = useDomainStore();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Domains</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400">Select a domain from the sidebar to manage its documents.</p>
      </div>

      {isLoading && (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-24 w-full" />
          ))}
        </div>
      )}

      {!isLoading && domains.length === 0 && (
        <Card>
          <CardContent className="py-12 text-center">
            <p className="text-slate-500 dark:text-slate-400">No domains yet. Click the + button next to "Domains" in the sidebar to create one.</p>
          </CardContent>
        </Card>
      )}

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {domains.map((domain) => (
          <Link
            key={domain.id}
            to={`/domains/${domain.id}/documents`}
            className="block"
          >
            <Card className="hover:border-emerald-500/50 transition-colors cursor-pointer">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div>
                    <CardTitle className="text-lg">{domain.name}</CardTitle>
                    <CardDescription>
                      <span className="text-xs font-mono">{domain.slug}</span>
                    </CardDescription>
                  </div>
                  <Badge variant={domain.role === "owner" ? "default" : "secondary"}>
                    {domain.role}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent>
                {domain.description && (
                  <p className="text-sm text-slate-600 dark:text-slate-300">{domain.description}</p>
                )}
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
